import React, { useEffect, useRef, useState } from "react";
import { Button, Layout, Radio, Steps, Tour } from "antd";
import TransferComponent from "../componenets/TransferComponent";
import useStore from "../store/useStore";
import { EditOutlined } from "@ant-design/icons";
const { Content } = Layout;

const publisheroptions = [
  {
    label: "천재 출판사",
    value: "CJ",
  },
  {
    label: "대교 출판사",
    value: "DK",
  },
  {
    label: "동아 출판사",
    value: "DA",
  },
  {
    label: "YBM 출판사 (최희경)",
    value: "YBMC",
  },
  {
    label: "YBM 출판사 (김혜리)",
    value: "YBMK",
  },
];

const gradeoptions = [
  {
    label: "5학년",
    value: 5,
  },
  {
    label: "6학년",
    value: 6,
  },
];

const Main = () => {
  const {
    currentStep,
    setStep,
    selectedGrade,
    setSelectedGrade,
    selectedUnits,
    selectedPublisher,
    setSelectedPublisher,
    setSelectedUnits,
    selectedWords,
    setSelectedWords,
    setRef,
  } = useStore();

  const [showTutorial, setShowTutorial] = useState(false);
  const handleTourChange = (current) => {
    if (current === 2 && !selectedGrade) {
      alert("학년을 선택해주세요!");
      return;
    }
    if (current === 3 && !selectedPublisher) {
      alert("교과서를 선택해주세요!");
      return;
    }
    if (current === 4 && selectedUnits.length === 0) {
      alert("단원을 선택해주세요!");
      return;
    }
    if (current === 5 && selectedWords.length < 3) {
      alert("단어는 최소 3개 이상 선택해야합니다!");
      return;
    }
    setStep(current);
  };

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();
  const ref6 = useRef();
  const ref7 = useRef();

  useEffect(() => {
    setRef("mainTutorial", "ref1", ref1.current);
    setRef("mainTutorial", "ref2", ref2.current);
    setRef("mainTutorial", "ref3", ref3.current);
    setRef("mainTutorial", "ref4", ref4.current);
    setRef("mainTutorial", "ref5", ref5.current);
    setRef("mainTutorial", "ref6", ref6.current);
    setRef("mainTutorial", "ref7", ref7.current);
  }, [setRef]);

  const onGradeChange = (checkedValues) => {
    setSelectedGrade(checkedValues);
    setStep(1);
    setSelectedUnits([]);
    setSelectedWords([]);
  };

  const onPublisherChange = (checkedValues) => {
    setSelectedPublisher(checkedValues);
    setStep(2);
    setSelectedUnits([]);
    setSelectedWords([]);
  };

  const tutorialSteps = [
    {
      title: (
        <>
          안녕하세요! <br />
          알공 단어장을 이용해 주셔서 고맙습니다!🙏 <br />
          단어장의 사용법에 대해 간단히 알려드릴게요!
        </>
      ),
      placement: "bottom",
      target: () => ref1.current,
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          단어장은 교과서 내용을 기반으로 만들어졌어요.
          <br />
          정보를 순차적으로 입력하기 위해
          <br />
          우선 <span className="bdbt">학년</span>을 선택해주세요!
        </>
      ),
      placement: window.innerWidth < 768 ? "bottom" : "right", // 모바일에서는 bottom, pc에서는 right
      target: () => ref2.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          학년을 선택 하셨다면, <span className="bdbt">교과서</span>를
          선택해주세요.
          <br />
          교과서도 역시 1개만 선택 가능합니다.
        </>
      ),
      placement: window.innerWidth < 768 ? "top" : "right",
      target: () => ref3.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          다음은 교과서의 단원을 선택하실 차례에요.
          <br />
          단원은 <span className="bdbt">다중 선택</span>이 가능합니다!
        </>
      ),
      placement: window.innerWidth < 768 ? "bottom" : "right",
      target: () => ref4.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          단원을 선택하셨다면, 오른쪽에 표시된 화면이 보일 거예요.
          <br />
          단어는 최소 3개 이상 선택해야 "저장하기" 버튼이 활성화됩니다.
          <br />
          체크 버튼을 해제하면 단어를 추가하거나 제거할 수 있어요!
        </>
      ),
      placement: window.innerWidth < 768 ? "bottom" : "left",
      target: () => ref5.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          아이콘을 눌러 <span className="bdbt">필터 기능</span>을 이용하면
          <br />
          훨씬 간편하게 단어장을 만들 수 있어요!
          <br />
        </>
      ),
      placement: window.innerWidth < 768 ? "bottom" : "right",
      target: () => ref6.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          이제 <span className="bdbt">저장하기</span> 버튼을 누르면 완성이에요!
          <br />
          고생하셨어요! 😄
          <br />
          여기까지 따라 와주셔서 감사합니다 🙏
        </>
      ),
      placement: "top",
      target: () => ref7.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "완료" },
    },
  ];

  useEffect(() => {
    const hasSeenMainTutorial = localStorage.getItem("hasSeenMainTutorial");
    if (!hasSeenMainTutorial) {
      setShowTutorial(true);
    }
  }, []);

  const handleClose = () => {
    setShowTutorial(false);
    localStorage.setItem("hasSeenMainTutorial", "true");
  };

  // 닫기 버튼 대신 다시 보지 않기 버튼 추가
  const tourStyle = {
    steps: tutorialSteps,
    open: showTutorial,
    onClose: handleClose,
  };

  return (
    <Layout>
      <Content className="w-full max-w-[1400px] min-h-[100vh] mx-auto pt-[50px] md:pt-[80px]">
        <div ref={ref1}>
          <Steps
            className="w-full max-w-[800px] m-auto my-5 md:my-8"
            current={currentStep}
            labelPlacement="vertical"
            items={[
              { title: "학년 선택" },
              { title: "교과서 선택" },
              { title: "단원" },
              { title: "선택된 단어" },
            ]}
          />
        </div>

        <div className="layout bg-transparent">
          <div className="main-sider">
            <div ref={ref2} className="selection-container">
              <h4>학년 선택</h4>
              <Radio.Group
                className="selection-group"
                options={gradeoptions}
                value={selectedGrade}
                onChange={(e) => onGradeChange(e.target.value)}
              />
            </div>

            <div ref={ref3} className="selection-container mt-8">
              <h4>교과서 선택</h4>
              <Radio.Group
                className="selection-group"
                options={publisheroptions}
                value={selectedPublisher}
                onChange={(e) => onPublisherChange(e.target.value)}
              />
            </div>
          </div>

          <Content className="step-wrap">
            <TransferComponent
              grade={selectedGrade}
              publisher={selectedPublisher}
              refs={{ ref4, ref5, ref6, ref7 }}
            />
          </Content>

          <Tour
            {...tourStyle}
            steps={tutorialSteps}
            current={currentStep}
            onChange={handleTourChange}
            indicatorsRender={(current, total) => (
              <span>
                {current + 1} / {total}
              </span>
            )}
            gap={{ radius: 8 }}
          />
        </div>

        <Button
          type="primary"
          className="floating-button"
          onClick={() =>
            window.open("https://forms.gle/rfnuXHm1irvLod2M9", "_blank")
          }
        >
          <EditOutlined />
          문의하기
        </Button>
      </Content>
    </Layout>
  );
};
export default Main;
